module.exports = __webpack_public_path__ + "static/fundwall_2-1210c978d8fe646e28fc173d2d3a49ff.jpg";